export const setOnWindow = (propertyName: string, property: any) =>
    (window[propertyName] = property);
